import { render, staticRenderFns } from "./InsertEvent.vue?vue&type=template&id=82b18648&scoped=true"
import script from "./InsertEvent.vue?vue&type=script&lang=js"
export * from "./InsertEvent.vue?vue&type=script&lang=js"
import style0 from "./InsertEvent.vue?vue&type=style&index=0&id=82b18648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b18648",
  null
  
)

export default component.exports